import trackCountChanges from '../helpers/trackCountChanges'
//------------------------------
// process specific count change
//------------------------------
export default function processSpecificCountChange({
  change = null, // not required for new character count
  count,
  original_counts,
  changed_counts,
  character,
}) {
  console.log('------------------------')
  console.log('IN processSpecificCountChange')
  console.log('1. count = ' + count.name)
  console.log('2. original_counts = ', window.$deepCopy(original_counts))
  console.log('3. changed_counts = ', window.$deepCopy(changed_counts))
  console.log('4. change = ', change)
  console.log('5. change.key = ' + change?.key)
  console.log('6. change.value = ' + change?.value)
  //--------------------------------------------------------
  // track count changes (performed in charactesheetcounts)
  //--------------------------------------------------------
  changed_counts = trackCountChanges({
    change,
    count,
    original_counts,
    changed_counts,
    character_id: character.id,
  })
  console.log('3. changed_counts = ', window.$deepCopy(changed_counts))
  //----------------------
  // return changed counts
  //----------------------
  return changed_counts
}
